import ICommonTextInput from './ICommonTextInput';
import { FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import * as React from 'react';
import FormValidationService from '../../shared/form/FormValidationService';

interface ICommonTextFormProps {
    input: ICommonTextInput;
    onChange: (e: any) => void;
    errors: any;
    save: (e: any) => void;
}

const CommonTextForm = (props: ICommonTextFormProps) => {
    return (
        <form onSubmit={props.save}>
            <FormGroup
                validationState={FormValidationService.getValidationState(props.errors.text)}
            >
                <ControlLabel>{Translate('common-texts/modal/form/input-label/text')}</ControlLabel>
                <FormControl
                    autoFocus
                    type="text"
                    name="text"
                    value={props.input.text}
                    onChange={props.onChange}
                />
                <HelpBlock>{props.errors.text}</HelpBlock>
            </FormGroup>
        </form>
    );
};

export default CommonTextForm;
